// REACT STUFF
/* eslint-disable */
import { Helmet } from 'react-helmet';
import {
  React,
  useState,
  useEffect
} from 'react';
import { useParams } from "react-router-dom";
import PropTypes from 'prop-types';
import {
  Box,
  Card,
  CardContent,
  Container,
  Grid,
  Select,
  Tab, 
  Tabs,
  MenuItem,
  InputLabel,
  FormControl,
} from '@mui/material';
// or
import { TabList,TabPanel,TabContext } from '@mui/lab';

// PAGES & COMPONENSTS
import DaysPerformance from 'src/components/dashboard/DataComponents/DaysPerformance';
import AggregatePerformance from 'src/components/dashboard/DataComponents/AggregatePerformance';
import CumulativePerformance from 'src/components/dashboard/DataComponents/CumulativePerformance';

const DataDashboard = (props) => {
  const { deviceId, date,cardCallback, token } = props;
  
  return (
    <Grid
      container
      spacing={3}
    >
    <Grid
      item
      lg={12}
      md={12}
      xl={6}
      xs={12}
    >
      <DaysPerformance token={token} deviceId={deviceId} date={date} />
    </Grid>
    <Grid
      item
      lg={12}
      md={12}
      xl={6}
      xs={12}
    >
      <CumulativePerformance token={token} cardCallback={cardCallback} deviceId={deviceId} date={date} />
    </Grid>
    <Grid
      item
      lg={12}
      md={12}
      xl={12}
      xs={12}
    > 
      <AggregatePerformance token={token} deviceId={deviceId} sx={{ height: '100%' }} />
    </Grid>
</Grid>

  );
};

DataDashboard.propTypes = {
  token: PropTypes.string,
  cardCallback: PropTypes.func,
  deviceId: PropTypes.array,
  date: PropTypes.instanceOf(Date)
};

export default DataDashboard;
